/**
 * 时间展示的**单一真源**。
 *
 * 原来这个函数是 `components/TaskCard.tsx` 里的模块级私有函数，分镜页要显示
 * 「这张图是什么时候出的」时又得抄一遍 —— 抄出来的两份迟早会分叉（一边改了
 * 格式另一边没改），所以提到这里共用。
 *
 * 只到「月-日 时:分」：这两个调用点都在任务/产物的上下文里，年份信息没用，
 * 反而会把一行挤成两行。
 */
export const fmtTime = (ms: number) =>
  new Date(ms).toLocaleString('zh-CN', {
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  })
